import { mergeDeep } from '../shared/helper'

export default class Setting {

  constructor(modelData, store) {

    const basicModelData = this.getDefault()

    if (modelData) {
      mergeDeep(basicModelData, modelData)
    }

    this.set(basicModelData)
    this.store = store
  }

  getDefault() {
    return {
      maintenanceMode: {
        value: false,
        meta: {
          visible: true,
          overwritable: false
        }
      },
      maintenanceWarningText: {
        value: {
          de: '',
          en: ''
        },
        meta: {
          visible: true,
          overwritable: false
        }
      },
      maintenanceTitle: {
        value: {
          de: '',
          en: ''
        },
        meta: {
          visible: true,
          overwritable: false
        }
      },
      maintenanceText: {
        value: {
          de: '',
          en: ''
        },
        meta: {
          visible: true,
          overwritable: false
        }
      },
      supportPassword: {
        value: '',
        meta: {
          visible: false,
          overwritable: false
        }
      },
      warningVersion: {
        value: 1,
        meta: {
          visible: true,
          overwritable: false
        }
      },
      warningDate: {
        value: '',
        meta: {
          visible: true,
          overwritable: false
        }
      },
      maintenanceWarningSwitch: {
        value: false,
        meta: {
          visible: true,
          overwritable: false
        }
      },
    }
  }

  set(data) {
    // clear for backward compatability (values that were strings and now objects for localization)
    const oldSet = ['maintenanceWarningText', 'maintenanceTitle', 'maintenanceText']
    oldSet.forEach((prop) => {
      if (typeof data[prop].value === 'string' || data[prop].value instanceof String || data[prop].value === null) {
        delete data[prop]
      }
    })

    mergeDeep(this, data)
  }

  getJSON() {
    return {
      maintenanceMode: this.maintenanceMode,
      maintenanceWarningText: this.maintenanceWarningText,
      maintenanceTitle: this.maintenanceTitle,
      maintenanceText: this.maintenanceText,
      supportPassword: this.supportPassword
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/settings/model.js